import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { ISubscription, IUserGroup } from '@core/interfaces/user-group.interface';
import { Observable } from 'rxjs';
import { ICampaignSprintPayload, IPurchaseCreatePayload, IUserGroupUpdatePayload } from './admin-user-group.interface';

@Injectable({
  providedIn: 'root',
})
export class AdminUserGroupService {
  private readonly http = inject(HttpClient);

  public getUserGroups(params?: HttpParams): Observable<IApiResponse<IUserGroup[]>> {
    return this.http.get<IApiResponse<IUserGroup[]>>('user-groups/admin', { params });
  }

  public getUserGroup(id: string, params?: HttpParams): Observable<IUserGroup> {
    return this.http.get<IUserGroup>(`user-groups/admin/${id}`, { params });
  }

  public updateUserGroup(id: string, payload: IUserGroupUpdatePayload): Observable<IUserGroup> {
    return this.http.put<IUserGroup>(`user-groups/admin/${id}`, payload);
  }

  public addPurchase(userGroupId: string, payload: IPurchaseCreatePayload): Observable<IUserGroup> {
    return this.http.post<IUserGroup>(`user-groups/${userGroupId}/purchases`, payload);
  }

  public addCampaignSprint(userGroupId: string, payload: ICampaignSprintPayload): Observable<IUserGroup> {
    return this.http.post<IUserGroup>(`user-groups/${userGroupId}/campaign-sprint`, payload);
  }

  public getSubscriptions(params?: HttpParams): Observable<IApiResponse<ISubscription[]>> {
    return this.http.get<IApiResponse<ISubscription[]>>('user-groups/subscriptions/admin', { params });
  }
}
